import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

// startsWith guard (like workers/app.ts): prerendered pages bake the
// build-time placeholder DSN ("your-dsn") into window.ENV.
if (ENV.MODE === 'production' && ENV.SENTRY_DSN?.startsWith('http')) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
